import React, { createContext, useContext, useEffect, useState } from "react"
import axios from "axios"

const USE_PING = false
const SERVER_PING_URL = "/ping"
const PING_INTERVAL = 10000

interface ConnectionContextProps {
    isOnline: boolean
    isServerReachable: boolean
    setIsServerReachable: (reachable: boolean) => void
}

const ConnectionContext = createContext<ConnectionContextProps>({
    isOnline: true,
    isServerReachable: true,
    setIsServerReachable: () => { },
})

export const useConnection = () => useContext(ConnectionContext)

const ConnectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine)
    const [isServerReachable, setIsServerReachable] = useState<boolean>(true)

    useEffect(() => {
        // Event-Listener für die Netzwerkverbindung
        const updateOnlineStatus = () => {
            setIsOnline(navigator.onLine)
        }

        window.addEventListener("online", updateOnlineStatus)
        window.addEventListener("offline", updateOnlineStatus)

        // Cleanup Event-Listener
        return () => {
            window.removeEventListener("online", updateOnlineStatus)
            window.removeEventListener("offline", updateOnlineStatus)
        }
    }, [isOnline])

    if (USE_PING) {
        useEffect(() => {
            // Funktion, um den Server-Ping zu überprüfen
            const pingServer = async () => {
                try {
                    await axios.get(SERVER_PING_URL)
                    setIsServerReachable(true)
                } catch (error) {
                    setIsServerReachable(false)
                    //console.error(error)
                }
            }

            // Ping den Server alle 10 Sekunden
            const interval = setInterval(pingServer, PING_INTERVAL)

            // Cleanup Intervall
            return () => clearInterval(interval)
        }, [])
    }

    return (
        <ConnectionContext.Provider value={{ isOnline, isServerReachable, setIsServerReachable }}>
            {children}
        </ConnectionContext.Provider>
    )
}
export default ConnectionProvider